import { render, staticRenderFns } from "./InsightsVariationsView.vue?vue&type=template&id=4f49df2c"
import script from "./InsightsVariationsView.vue?vue&type=script&lang=js"
export * from "./InsightsVariationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports